import React, { useEffect, useEffectEvent } from 'react';
import AppHeader from '../../common/app-header/AppHeader';
import { document_sign_url } from '../../common/constants/allowed_iframe_urls';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import styles from '../library-item-details/LibraryItemDetails.module.scss';
import { Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDocumensoRedirect } from '../../common/hooks/useDocumensoRedirect';

const SigningPage = () => {
  const { documentId } = useParams();
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const view = params.get('view');
  const backUrl = params.get('backUrl');
  const activeTab = params.get('activeTab');
  const { redirectToDocumenso, isLoading, error } = useDocumensoRedirect();

  const destinationPath = document_sign_url(String(documentId), view === 'true');

  const startRedirect = useEffectEvent(() => {
    if (!isLoading && !error) {
      redirectToDocumenso(destinationPath);
    }
  });

  // Kick off the redirect once on mount.
  useEffect(() => {
    startRedirect();
  }, []);

  return (
    <>
      <AppHeader title={t('headers.signingPageHeader')} />
      <Box className={styles.breadcrumbs} sx={{ mb: '32px' }}>
        <Link
          id='signingBackLink'
          className={styles.documentViewText}
          to={backUrl + (activeTab ? `?activeTab=${activeTab}` : '')}
        >
          {t('buttons.back')}
        </Link>
      </Box>
      {isLoading ? (
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '200px',
          }}
        >
          <Typography>{t('messages.redirectingToDocumenso')}</Typography>
        </Box>
      ) : error ? (
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '32px',
            minHeight: '200px',
          }}
        >
          <Typography color='error'>Error: {error}</Typography>
          <Button
            id='signingRetryBtn'
            variant='contained'
            onClick={() => redirectToDocumenso(destinationPath)}
          >
            {t('buttons.retry')}
          </Button>
        </Box>
      ) : (
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '200px',
          }}
        >
          <Typography>{t('messages.redirectingToDocumenso')}</Typography>
        </Box>
      )}
    </>
  );
};

export default SigningPage;
